import { useState } from 'react';
import { Button, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { CreateTemplateModal, type TemplateKind } from '../CreateTemplateModal';
import styles from './TemplateListToolbar.module.css';

const LABELS: Record<TemplateKind, { noun: string; button: string }> = {
  worksheet: { noun: 'worksheet template', button: 'New Worksheet' },
  report: { noun: 'report template', button: 'New Report Template' },
};

interface TemplateListToolbarProps {
  kind: TemplateKind;
  count: number | undefined;
}

/** Shared header above the worksheet and report template lists. */
export function TemplateListToolbar({ kind, count }: TemplateListToolbarProps) {
  const [open, setOpen] = useState(false);
  const labels = LABELS[kind];
  const total = count ?? 0;

  return (
    <div className={styles.toolbar}>
      <Typography.Text type="secondary">
        {`${total} ${labels.noun}${total === 1 ? '' : 's'}`}
      </Typography.Text>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={() => setOpen(true)}
      >
        {labels.button}
      </Button>
      <CreateTemplateModal
        kind={kind}
        open={open}
        onClose={() => setOpen(false)}
      />
    </div>
  );
}
